var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16504,
    y: 0.98999,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#F5FBEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16504,
    y: 0.98999,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1455 12.5903C26.4463 12.6724 26.665 12.9185 26.665 13.2192C26.665 20.2466 20.9775 25.9067 13.9775 25.9067C13.6494 25.9067 13.4033 25.7153 13.3213 25.4146L12.665 22.5708C12.6104 22.27 12.7471 21.9419 13.0479 21.8052L16.1104 20.4927C16.3838 20.3833 16.6846 20.4653 16.876 20.6841L18.2432 22.3521C20.376 21.3403 22.0986 19.5903 23.083 17.5122L21.415 16.145C21.1963 15.9536 21.1143 15.6528 21.2236 15.3794L22.5361 12.3169C22.6729 12.0161 23.001 11.8521 23.3018 11.9341L26.1455 12.5903Z",
    fill: "#3A6D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.8bbc03bc8943382727dcd8f113150255.svg";
export { ForwardRef as ReactComponent };